module.exports = __webpack_public_path__ + "img/media-zh.0349258c.jpg";